import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Numeral from "../../../components/numeral/Numeral";
import { HttpRequest } from "../../../services/httpRequest";
import {
  conveniosEfecty,
  conveniosRecaudo,
  conveniosWU,
} from "../../../utils/conveniosRecaudo";
import moment from "moment";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import "../../../index.css";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { SkeletonPayloginPage } from "./components/skeleton_paylogin_page";
import { Download } from "lucide-react";
import html2PDF from "jspdf-html2canvas";
import { useRef } from "react";
import { IndexedDBService } from "../../../services/indexedDbService";
import { checkCreditPayable } from "./helpers/payment-gate";

const indexedDbService = new IndexedDBService();

export function NewCashPayPage() {
  const { due } = useCredit();
  let navigate = useNavigate();
  const [dataReference, setDataReference] = useState(null);
  const [methodPyment, setMethodPyment] = useState(null);
  const [basicInfo, setBasicInfo] = useState({});
  const [creditsInfo, setCreditsInfo] = useState([]);
  const [, setUserInfoAuth] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [deudaAFecha, setDeudaAFecha] = useState(0);
  const [, setCosts] = useState([]);
  const receiptRef = useRef(null);

  const paymentMethodsMap = {
    bancolombia: "Bancolombia",
    efecty: "Efecty",
    "western-union": "Western Union",
  };

  const conveniosMap = {
    bancolombia: conveniosRecaudo,
    efecty: conveniosEfecty,
    "western-union": conveniosWU,
  };

  const selectedMethodLabel = paymentMethodsMap[methodPyment] || "";
  const selectedConvenios = conveniosMap[methodPyment] || [];

  const loadCredits = useCallback(async () => {
    try {
      const data = await HttpRequest.getAllCreditUser(
        localStorage.getItem("doc"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoUserAuth = useCallback(async () => {
    try {
      const data = await HttpRequest.getUserAuth(localStorage.getItem("doc"));
      return data.message.user;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoUser = useCallback(async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoQuota = useCallback(async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleDownloadPDF = async () => {
    const element = receiptRef.current;

    if (!element) return;

    await html2PDF(element, {
      jsPDF: {
        format: "a4",
      },
      imageType: "image/jpeg",
      output: `referencia-de-pago.pdf`,
      html2canvas: {
        scale: 2,
        useCORS: true,
      },
    });
  };

  const backToHome = () => {
    navigate("/pagar");
    indexedDbService.deleteItem(localStorage.getItem("credit_id"));
    indexedDbService.deleteItem("methodPyment");
  };

  const getDataReference = useCallback(async () => {
    let data = await indexedDbService.findItem(
      "id",
      localStorage.getItem("credit_id"),
    );

    let methodPyment = await indexedDbService.findItem("id", "methodPyment");
    console.log("DATA REF:", methodPyment);

    setMethodPyment(methodPyment.subMetodo);
    setDataReference(data);
  }, []);

  const configData = useCallback(async (credit, infoCupo) => {
    let costsFeatures;
    let infoDeudaBackend;
    let deudahoy;
    try {
      let versionTarifas = credit?.versionTarifas;
      let responseData =
        versionTarifas === "2"
          ? await HttpRequest.calcularDeudaV2({
            credit: credit,
            infoCupo: infoCupo,
          })
          : await HttpRequest.calcularDeuda({
            credit: credit,
            infoCupo: infoCupo,
          });
      infoDeudaBackend = responseData.message.deuda;
      costsFeatures = infoDeudaBackend?.costsFeature;
      deudahoy = infoDeudaBackend?.deudaAFecha;
    } catch (error) {
      console.log(error);
    }
    setDeudaAFecha(deudahoy);
    setCosts(costsFeatures);
    return;
  }, []);

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadCreditsUser = async () => {
      let credits = await loadCredits();
      return credits;
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    const loadUserAuth = async () => {
      let userAuth = await loadInfoUserAuth();
      return userAuth;
    };

    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    const determinaCreditoAMostrar = (credits = []) => {
      let vigente = credits.filter((credit) => credit.status === "Vigente");
      let cancelado = credits.filter((credit) => credit.status === "Cancelado");
      let enMora = credits.filter((credit) => credit.status === "En mora");
      let pendienteFirma = credits.filter(
        (credit) => credit.status === "Pendiente de firmar",
      );
      let solRechazada = credits.filter(
        (credit) => credit.status === "Solicitud rechazada",
      );
      let sinEstado = credits.filter((credit) => credit.status === "");

      if (vigente.length > 0) {
        return vigente;
      } else if (cancelado.length > 0) {
        return cancelado;
      } else if (enMora.length > 0) {
        return enMora;
      } else if (pendienteFirma.length > 0) {
        return pendienteFirma;
      } else if (solRechazada.length > 0) {
        return solRechazada;
      } else if (sinEstado.length > 0) {
        return sinEstado;
      }
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        let credit;
        let info;
        let userAuth;
        if (isValidToken) {
          try {
            // Entrar directo a esta URL no debe saltarse la validación de "Generar referencia": si el
            // crédito aún no puede pagar, se avisa y se vuelve a /pagar. Ante un fallo técnico se deja
            // ver la página (es solo informativa; la referencia ya se validó en el paso anterior).
            // El tipo de pago (novación o no) se guardó al elegir la opción en /pagar.
            const storedPayment = await indexedDbService
              .findItem("id", localStorage.getItem("credit_id"))
              .catch(() => null);
            const payable = await checkCreditPayable(
              undefined,
              storedPayment?.hasExtend === true,
            );
            if (!payable.ok && payable.blocked) {
              alert(payable.message);
              navigate("/pagar");
              return;
            }
            userAuth = await loadUserAuth();
            info = await loadInfo();
            setBasicInfo(info);
            setUserInfoAuth(userAuth);
            getDataReference();
            let cupo = await loadQuotaStatus();
            let creditData = await loadCreditsUser();
            if (creditData.length === 0) {
              alert("No tienes creditos activos.");
            } else {
              credit = determinaCreditoAMostrar(creditData);
              if (credit[0].status !== "Cancelado") {
                //determinarMora(credit[0].acceptanceDate, credit[0].termInDays);
              } else if (credit[0].status === "Solicitud rechazada") {
                console.log("Credito denegado");
              }
              configData(credit[0], cupo);
              setCreditsInfo(credit);
            }
            setIsLoading(false);
          } catch (error) {
            console.log(error);
            return;
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [
    navigate,
    loadCredits,
    loadInfoUserAuth,
    loadInfoUser,
    loadInfoQuota,
    getDataReference,
    configData,
  ]);

  if (isLoading) {
    return <SkeletonPayloginPage title={"Recibo de pago"}/>;
  }

  return (
    <DashboardMyCredit
      name={basicInfo.firstname}
      balance={creditsInfo[0].status === "Cancelado" ? 0 : deudaAFecha}
      current={"2"}
      title={"Recibo de pago"}
      due={due}
      justify={"center"}
      flexWrap={"wrap"}
      display={"flex"}
      height={"97%"}
      main={
        <div>
          {creditsInfo[0].status === "Cancelado" ? (
            <div className="py-10">
              <h2>Esta al dia con su credito</h2>
            </div>
          ) : creditsInfo[0].status === "Solicitud rechazada" ? (
            <div className="py-10">
              <h2>No tiene una deuda activa.</h2>
            </div>
          ) : (
            <div ref={receiptRef} className="flex flex-col h-full w-auto bg-white px-8 py-5 rounded-3xl shadow-lg mt-8 md:w-125">
              <button
                data-html2canvas-ignore="true"
                onClick={handleDownloadPDF}
                className="p-2 -mr-2 flex justify-end rounded-full hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600"
                aria-label="Cerrar"
              >
                <Download
                  className="size-6 text-gray-400 hover:text-gray-600 cursor-pointer"
                  strokeWidth={2}
                />
              </button>

              {/* SUCCESS ICON */}
              <div className="flex justify-center">
                <div className="w-40 h-20  flex items-center justify-center">
                  <img
                    className="w-auto h-12 mr-2"
                    src={
                      methodPyment === "bancolombia"
                        ? "/png/bancolombia-completo.png"
                        : methodPyment === "efecty"
                          ? "/png/efecty.png"
                          : "/png/wu-accival.png"
                    }
                    alt="medios-de-pago-galilea"
                  />
                </div>
              </div>

              {/* TITLE */}
              <h2 className="text-center text-2xl font-bold text-gray-900 mb-2">
                Referencia generada
              </h2>

              {/* CARD INFO */}
              <div
                className="rounded-2xl overflow-hidden mb-8"
                style={{
                  border: "1px solid #f3f4f6",
                }}
              >
                {/* Convenios */}

                {selectedConvenios.length > 0 && (
                  <div className="px-5 py-2 space-y-3">
                    {selectedConvenios.map((convenio, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-start"
                      >
                        <span className="text-gray-500">{convenio.item}</span>
                        <span className="font-medium text-right">
                          {convenio.value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                {/* Punto de pago */}
                <div
                  className="flex justify-between px-5 pb-4"
                  style={{
                    borderBottom: "1px solid #7f22fe",
                  }}
                >
                  <span className="text-gray-500">Punto de pago</span>
                  <span className="font-medium">{selectedMethodLabel}</span>
                </div>

                <div className="flex justify-between px-5 pt-4 pb-2">
                  <span className="text-gray-500">Fecha de vencimiento</span>
                  <span className="font-medium">
                    {moment(new Date()).format("DD/MM/YYYY")}
                  </span>
                </div>

                <div className="flex justify-between px-5 pb-4">
                  <span className="text-gray-500">Monto a pagar</span>
                  <span className="text-[#00bc7d]">
                    {dataReference && (
                      <Numeral format={"$0,0"} value={dataReference.amount} />
                    )}
                  </span>
                </div>
              </div>

              {/* BUTTON */}
              <button
                data-html2canvas-ignore="true"
                onClick={() => {
                  backToHome();
                }}
                className="w-full py-4 rounded-full text-white border-[#7f22fe] bg-[#7f22fe] hover:opacity-90 transition flex items-center justify-center gap-4"
                style={{ cursor: "pointer" }}
              >
                Volver al inicio
              </button>
              <p
                style={{
                  marginTop: "10px",
                  fontSize: "12px",
                  textAlign: "center",
                  color: "#6c6d6f",
                }}
              >
                Descarga el comprobante y acercate al corresponsal{" "}
                {selectedMethodLabel} mas cercano
              </p>
            </div>
          )}
        </div>
      }
    />
  );
}
